import React from 'react';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function ForWhoSection() {
  const forYou = ['Eres mamá primeriza', 'Te sientes perdida entre tanta info', 'Quieres alimentar mejor sin enloquecer'];
  const notForYou = ['No te interesa cocinar', 'Quieres recetas gourmet o complicadas', 'Buscas un manual técnico'];
  return <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-baby-pink-light to-baby-blue-light" data-id="element-525">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-526">
        <div className="text-center mb-8 sm:mb-12 animate-fade-in-up" data-id="element-527">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-528">
            ¿Para Quién Es Este Ebook?
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 sm:gap-8" data-id="element-529">
          {/* For You */}
          <div className="bg-white/95 backdrop-blur-baby p-6 sm:p-8 rounded-baby-lg shadow-baby-glow border-2 border-baby-blue animate-fade-in-up" data-id="element-530">
            <h3 className="text-xl sm:text-2xl font-extrabold text-gray-900 mb-6 text-center" data-id="element-531">
              ✓ Este ebook es para ti si:
            </h3>
            <div className="space-y-4 stagger-children" data-id="element-532">
              {forYou.map((item, index) => <div key={index} className="flex items-start gap-3 bg-baby-blue-light/50 p-4 rounded-baby" data-id="element-533">
                  <CheckCircleIcon className="w-6 h-6 text-baby-blue-dark flex-shrink-0 mt-0.5" data-id="element-534" />
                  <p className="text-sm sm:text-base text-gray-900 font-bold" data-id="element-535">
                    {item}
                  </p>
                </div>)}
            </div>
          </div>

          {/* Not For You */}
          <div className="bg-white/95 backdrop-blur-baby p-6 sm:p-8 rounded-baby-lg shadow-baby-soft border-2 border-gray-300 animate-fade-in-up" style={{
          animationDelay: '0.2s'
        }} data-id="element-536">
            <h3 className="text-xl sm:text-2xl font-extrabold text-gray-900 mb-6 text-center" data-id="element-537">
              ✗ No es para ti si:
            </h3>
            <div className="space-y-4 stagger-children" data-id="element-538">
              {notForYou.map((item, index) => <div key={index} className="flex items-start gap-3 bg-gray-100 p-4 rounded-baby" data-id="element-539">
                  <XCircleIcon className="w-6 h-6 text-gray-600 flex-shrink-0 mt-0.5" data-id="element-540" />
                  <p className="text-sm sm:text-base text-gray-900 font-bold" data-id="element-541">
                    {item}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}